// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"_2Z_TS","list":"dZJQN","listItem":"_1YIf3","firstTier":"_1R5Ut","secondTier":"_2LaWN","listItemImg":"_3G5Eb"};